import type { CSSProperties } from 'react';

/** The panel the date and time pickers open under their field. Token colours
 *  so it follows the theme; the same treatment as the workshop-type list. */
export const PICKER_POPOVER: CSSProperties = {
  position: 'absolute',
  zIndex: 30,
  top: 'calc(100% + 2px)',
  left: 0,
  margin: 0,
  padding: 6,
  background: 'var(--nb-bg)',
  border: '1px solid var(--nb-border-2)',
  borderRadius: 8,
  boxShadow: '0 8px 24px rgba(0,0,0,.18)',
};
